import CartCommon from '@/app-core/mixins/cart/cartCommon'

export default {
  name      : 'CartStoreMinimumOrderWarning',
  components: {},
  directives: {},
  mixins    : [CartCommon],
  props     : {
    storeId: {
      type   : [Number, String],
      default: null
    },

    dense: {
      type   : Boolean,
      default: false
    },

    sortText: {
      type   : Boolean,
      default: false
    },

    text: {
      type   : Boolean,
      default: false
    },

    color: {
      type   : String,
      default: 'info'
    },

    coloredBorder: {
      type   : Boolean,
      default: false
    },

    border: {
      type   : String,
      default: 'left'
    }
  },
  enums    : {},
  dataModel: null,
  data() {
    return {}
  },
  computed: {},
  watch   : {},
  beforeCreate() {
  },
  created() {
  },
  beforeMount() {
  },
  mounted() {
  },
  beforeUpdate() {
  },
  updated() {
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  methods: {}
}
